import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Contract } from '@models/contract';
import { ContractWidget } from '@models/contract-widgets';
import { PortalCollapsibleComponent, PortalWidgetDetailsComponent } from 'app/customer-portal';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-insured-instrument-widget',
    imports: [PortalCollapsibleComponent, SharedModule, PortalWidgetDetailsComponent],
    templateUrl: './insured-instrument-widget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuredInstrumentWidgetComponent implements ContractWidget {
    @Input({ required: true })
    public contract: Contract;

    protected get instrument(): string {
        return this.contract.insuranceObject;
    }

    protected get price(): number {
        return this.contract.objectValue;
    }
}
